var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserBox1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 554.953,
    viewBox: "0 0 640 554.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221a3e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-box-1",
    transform: "translate(-3461 -4565.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_4",
    "data-name": "Union 4",
    transform: "translate(-10463 4693.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M14544,426.844h-600a18.982,18.982,0,0,1-19-19V-67.451a18.885,18.885,0,0,1,1.492-7.4,18.956,18.956,0,0,1,4.071-6.04,18.942,18.942,0,0,1,6.039-4.072,18.876,18.876,0,0,1,7.395-1.493h19.98l.3-.363,32.685-39.57a1.992,1.992,0,0,1,1.541-.725,1.989,1.989,0,0,1,1.54.725l32.687,39.57.3.363H14544a18.879,18.879,0,0,1,7.4,1.493,18.934,18.934,0,0,1,6.04,4.072,18.944,18.944,0,0,1,4.072,6.04,18.868,18.868,0,0,1,1.493,7.4V407.844a18.985,18.985,0,0,1-19,19Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M14544,423.844a18,18,0,0,0,18-18V-67.451a17.881,17.881,0,0,0-5.272-12.728A17.883,17.883,0,0,0,14544-85.451H14032.56l-.6-.726-32.686-39.57a.984.984,0,0,0-.77-.362.984.984,0,0,0-.77.362l-33.285,40.3H13944a17.875,17.875,0,0,0-12.726,5.272A17.884,17.884,0,0,0,13926-67.451V405.844a18,18,0,0,0,18,18h600m0,2h-600a20,20,0,0,1-20-20V-67.451a20,20,0,0,1,20-20h19.51l32.686-39.57a3,3,0,0,1,4.623,0l32.686,39.57H14544a20,20,0,0,1,20,20V405.844A20,20,0,0,1,14544,425.844Z",
    fill: "#5e547c"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 640,
    transform: "translate(3461 4908)",
    fill: "none",
    stroke: "#5e547c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16-2",
    "data-name": "Line 16",
    x2: 640,
    transform: "translate(3461 4997)",
    fill: "none",
    stroke: "#5e547c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 640,
    transform: "translate(3461 4834)",
    fill: "none",
    stroke: "#5e547c",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBox1);
export default __webpack_public_path__ + "static/media/user-box-1.7b9516fcf8df48874768a376a8dcd36c.svg";
export { ForwardRef as ReactComponent };